import { $, $$ } from 'utils/dom';

export default class EventList {
  constructor(container, hideSameDate = true) {
    this.container = container;
    this.eventItems = $$('.event-list-item', container);
    this.hideSameDate = hideSameDate;
  }

  setEventDates() {
    let lastDate = '';

    this.eventItems.forEach(event => {
      const time = $('time', event);
      const timeStamp = time.getAttribute('datetime');
      const eventDate = new Date(timeStamp).toISOString().split('T')[0];

      // only add new infos if it's a new day
      if (eventDate === lastDate && this.hideSameDate) {
        [
          $('.event-list-item__date', event),
          $('.event-list-item__month', event),
          $('.event-list-item__day', event),
        ].forEach(el => el.classList.add('visibility-hidden'));
      }

      lastDate = eventDate;
    });
  }

  init() {
    this.setEventDates();
  }
}
